import { render, staticRenderFns } from "./OrganismFloatingButton.vue?vue&type=template&id=4ea2d5e3&"
import script from "./OrganismFloatingButton.vue?vue&type=script&lang=js&"
export * from "./OrganismFloatingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports